export default [{"tag":"path","att":{"d":"M15 7v4h-4v4H7v4H3v2h6v-4h4v-4h4V9h4V7h-6zM4 3v2h2.59L3 8.59 4.41 10 8 6.41V9h2V3H4z"}}]